<template>
  <v-layout column>
    <v-flex class>
      <div class="d-flex flex-row">
        <div style="margin-right:30px;" v-if="row_co.co_avatar">
          <v-img
            :src="srcAvatar"
            :height="short?'90px':'180px'"
            :width="short?'90px':'180px'"
            class="rounded-image"
          ></v-img>
        </div>
        <div v-else style="margin-right:30px;">
          <div :class="{'container-no-avatar':true, 'rounded-image':true, 'short':short}">
            <div ref="noavatar" :class="{'no-avatar':true, 'rounded-image':true}"></div>
          </div>
        </div>
        <div class="d-flex align-content-center flex-wrap">
          <div>
            <h1>
              <span v-html="$options.filters.formatContactName(row_co,true)"></span>
              <!-- <span v-if="row_co.co_society">&nbsp;|&nbsp;{{row_co.co_society}}</span> -->
            </h1>
            <h2 v-if="row_co.co_function">{{row_co.co_function}}</h2>
            <h3 v-if="row_co.co_type!='contact'">Droit : {{co_type_text}}</h3>
          </div>
        </div>

        <!-- <span class="client mr-3" :class="clientSuiviClass">{{clientsuiviLabel}}</span> -->
        <div class="ml-auto">
          <v-btn
            color="info"
            depressed
            @click="openWinEdit()"
            :disabled="!$store.state.myrights.Create_contact"
          >Modifier</v-btn>
        </div>
      </div>

      <v-row>
        <v-col md6>
          <h2>Coordonnées</h2>
          <div>
            <div>{{row_co.co_address1}}</div>
            <div>{{row_co.co_address2}}</div>
            <div>{{row_co.co_address3}}</div>
            <div>{{row_co.co_zip}}</div>
            <div>{{row_co.co_city}}</div>
            <div>{{row_co.co_country}}</div>
          </div>
        </v-col>
        <v-col md6>
          <h2>Coordonnées</h2>
          <div>
            <div>e-mail : {{row_co.co_email}}</div>
            <div>tel : {{row_co.co_tel}}</div>
          </div>
        </v-col>
      </v-row>
      <v-row class="right">
        <v-col>
          <h2>Les droits</h2>
          <ul class="list-right" v-if="row_co.co_right">
            <li v-for="(right, index) in $store.state.rights" :key="index">
              <div class="d-flex flex-row">
                <v-icon>{{row_co.co_right[right.value] ? "mdi-check text-green" : "mdi-close-circle text-red"}}</v-icon>
                <div
                  class="ml-2"
                  :class="row_co.co_right[right.value]  ? '' : 'text-red'"
                >{{right.text}}</div>
              </div>
            </li>
          </ul>
        </v-col>
      </v-row>
      <contact-win-edit
        ref="ContactWinEdit"
        @contactWinEditSaved="contactWinEditSaved"
        @contactWinEditCanceled="contactWinEditCanceled"
        @contactWinEditDeleted="contactWinEditDeleted"
      ></contact-win-edit>

      <!-- <m-confirm-dialog
      v-model="confirmDeleteSearchDialog"
      text="Souhaitez-vous effacer cette recherche ?"
      title="Confirmation"
      @canceled="confirmDeleteSearchDialog=false"
      @confirmed="deleteSearchOk()"
      ></m-confirm-dialog>-->
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "contactdetails",
  components: {},
  props: {
    value: Number,
    short: Boolean
  },
  data() {
    let actionsShowMore = [];
    for (let i = 0; i < 50; i++) {
      actionsShowMore["chk" + i] = false;
    }
    return {
      // contactsassociated: [],
      confirmDeleteSearchDialog: false,
      actionsNbMax: 2,
      showFinancialBtn: true,
      showFinancial: false,
      actionsShowMore: actionsShowMore,
      filterfrom: this.$moment()
        .add(-1, "month")
        .format("YYYY-MM-DD"),
      filterto: this.$moment().format("YYYY-MM-DD"),
      // row_co: this.value ? this.value : this.defaultContact(),
      row_co: this.defaultContact(),

      financialparts: [
        ["co_annualincomes", "Ressources : Revenu / mois"],
        ["co_familybenefits", "Ressources : Allocations familliales / mois"],
        ["co_realincomes", "Ressources : Revenus immobiliers / mois"],
        ["co_othersincomes", "Ressources : Autres revenus / mois"],
        ["co_alimonies", "Charges : Pensions alimentaires / mois"],
        ["co_consumercredit", "Charges : Crédits consommation / mois"],
        ["co_automobilecredit", "Charges : Crédits automobile / mois"],
        ["co_otherscredit", "Charges : Autres crédits / mois"],
        ["co_ratedebt", "Résultat : Taux endettement maxi (%)"],
        ["co_rateloan", "Résultat : Taux du prêt (%)"],
        ["co_durationloan", "Résultat : Durée du prêt (années)"],
        ["co_financialallocation", "Résultat : Enveloppe financière"]
      ]
    };
  },
  computed: {
    srcAvatar() {
      return (
        this.$config.server_url +
        "/api/1.0/avatar/" +
        this.row_co.co_id +
        "/180/180?d=" +
        this.row_co.updatedAt
      );
    },
    co_type_text() {
      return this.$_.result(
        this.$_.find(this.$store.state.items_co_type, {
          value: this.$store.state.user.co_type
        }),
        "text",
        "N/A"
      );
    }
  },
  mounted() {
    if (this.value) {
      this.loadContact();
    }
  },
  created() {},
  watch: {
    value(val) {
      // this.row_co = val ? val : this.defaultContact();
      this.loadContact();
    }
  },
  methods: {
    defaultContact() {
      return {
        newcustomers: [],
        properties: [],

        contactsassociated: [],

        calls_user: [],
        calls_contact: [],
        todos_user: [],
        todos_todo_user: [],
        todos_contact: [],
        signatures_sell_user: [],
        signatures_sell_contact: [],
        signatures_rent_user: [],
        signatures_rent_contact: [],
        emails_user: [],
        emails_contact: [],
        presents_user: [],
        presents_contact: [],
        visits_user: [],
        visits_contact: [],
        reports_user: [],
        reports_contact: [],
        reports_tocomplete: []
      };
    },
    clickShowMore(actionstabindex) {
      this.actionsShowMore["chk" + actionstabindex] = !this.actionsShowMore[
        "chk" + actionstabindex
      ];
      this.$forceUpdate();
    },

    async loadContact() {
      this.showFinancialBtn = false;
      this.showFinancial = false;
      for (let i = 0; i < 50; i++) {
        this.actionsShowMore["chk" + i] = false;
      }
      if (!this.value) {
        this.row_co = this.defaultContact();
        this.$emit("contactDetailsLoaded", null);
        return;
      }
      let params = {};
      if (this.filterfrom) params.filterfrom = this.filterfrom;
      if (this.filterto) params.filterto = this.filterto;
      let response = await this.$axios.get(
        this.$config.server_url + "/api/1.0/contacts/" + this.value,
        { params }
      );
      this.row_co = response.data.data;

      // console.log("this.row_co details", this.row_co);
      // console.log("response.data.data co", response.data.data);
      for (
        let iFinanciel = 0;
        iFinanciel < this.financialparts.length;
        iFinanciel++
      ) {
        if (this.row_co[this.financialparts[iFinanciel][0]])
          this.showFinancialBtn = true;
      }

      this.$emit("contactDetailsLoaded", this.row_co.co_id);

      // this.$router.push("/contacts/" + this.contact.co_id + "/details");var text = 'Making the Web a Better Place Making the Web';
      this.$nextTick(() => {
        if (this.row_co.co_avatar) return;
        var text = "";
        text =
          this.row_co.co_name.slice(0, 1) +
          this.row_co.co_firstname.slice(0, 1);
        if (text.length < 2) text = this.row_co.co_name.slice(0, 2);
        if (this.row_co.co_name && this.row_co.co_firstname)
          text =
            this.row_co.co_name.slice(0, 1) +
            this.row_co.co_firstname.slice(0, 1);
        else if (this.row_co.co_name) text = this.row_co.co_name.slice(0, 2);
        else if (this.row_co.co_firstname)
          text = this.row_co.co_firstname.slice(0, 2);
        else text = "--";
        console.warn(text);
        this.$refs.noavatar.innerHTML = text;
      });
    },

    async deleteSearchOk() {
      await this.$axios.delete(
        this.$config.server_url + "/api/1.0/searches/" + this.searchToDelete
      );
      this.loadContact();
      this.confirmDeleteSearchDialog = false;
    },
    openWinEdit() {
      this.$refs.ContactWinEdit.open(this.value);
      this.$emit("contactWinEditOpen", this.value);
    },

    // cancelWin() {
    //   this.dialog = false;
    // },
    // async saveWin() {
    //   await this.$axios.put(
    //     this.$config.server_url + "/api/1.0/visits/" + this.row_vi.vi_id,
    //     this.row_vi
    //   );
    //   this.dialog = false;
    // },
    contactWinEditSaved(co_id) {
      this.loadContact();
      this.$emit("contactWinEditSaved", co_id);
      // this.$emit("change", co_id);
    },
    contactWinEditCanceled(co_id) {
      this.$emit("contactWinEditCanceled", co_id);
    },
    contactWinEditDeleted(co_id) {
      //this.$store.dispatch("load_nbclientsuivi");
      this.$emit("contactWinEditDeleted", co_id);
      // this.$emit("change", co_id);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../sass/variables.scss";
.right {
  background-color: #f1f1f1; //$gris
}
.list-right {
  margin-top: 10px;
  list-style: none;
}
////////////immo//////
.h-100 {
  height: 100%;
}
.tableinfos {
  td {
    padding-right: 20px;
  }
}
.client-suivi {
  background-color: #8dc38d;
}
.client-nonsuivi {
  background-color: #c5c5c5;
}
.client {
  color: #fff;
  padding: 8px;
  border-radius: 20px;
}
.card3 {
  .text-md-center {
    line-height: 1rem;
  }
  h1 {
    margin: 5px 0 0 0;
  }
}
.container-no-avatar {
  width: 180px;
  height: 180px;
  display: flex;
  position: relative;
  background-color: $gris;
  .no-avatar {
    width: 150px;
    height: 150px;
    position: absolute;
    top: 15px;
    left: 15px;

    display: flex;
    color: #c5c5c5;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    font-size: 4rem;
    overflow: hidden;
  }
  &.short {
    width: 80px;
    height: 80px;
    .no-avatar {
      font-size: 2rem;
      top: 0;
      left: 0;
      width: 90px;
      height: 90px;
    }
  }
}
</style>